import { useConfig } from "app/contexts/ConfigContext";

/**
 * Whether the Anthropic integration is available (the "anthropic-integration"
 * dev flag). The platform gates the integration's GraphQL types behind the
 * flag of the same name, so nothing may query them while this is false.
 */
export function useIsAnthropicIntegrationAvailable() {
  const config = useConfig();

  return Boolean(config?.dev_flags?.includes("anthropic-integration"));
}
